module.exports = __webpack_public_path__ + "img/9788961700580.6aa92ae0.jpg";